import axios from "axios";

const estabelecimentoApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/estabelecimento`
})

async function servGetAllEstabelecimentos(somenteAtivos, enviaRelatorioAcompanhamento) {

    const response = await estabelecimentoApi.get('', {
        params: { somenteAtivos, enviaRelatorioAcompanhamento }
    })

    return response.data
}

async function servGetEstabelecimentoPorNome(nomeEstabelecimento, somenteAtivos, enviaRelatorioAcompanhamento) {

    const response = await estabelecimentoApi.get('por-nome', {
        params: { nomeEstabelecimento, somenteAtivos, enviaRelatorioAcompanhamento }
    })

    return response.data
}

export {
    servGetAllEstabelecimentos,
    servGetEstabelecimentoPorNome
}